// @ts-check

import UkkoturvaIndex from '@/views/ukkoturva/UkkoturvaIndex.vue'

import { service } from '@/core/constants'
import {
  AUTHENTICATION_REQUIRED,
  HIDE_TITLE_ON_MOBILE,
  IS_IN_MAIN_NAV,
  ROUTE_NAME
} from '@/router/meta'

/** @type {import('vue-router').RouteRecordRaw} */
export const UKKOTURVA_ROUTE_OVERVIEW = {
  path: 'overview',
  name: 'ukkoturva_overview',
  component: () => import('@/views/ukkoturva/UkkoAssuranceOverview.vue'),
  meta: {
    scrollToTop: true,
    requiresAuth: true,
    showInMainNav: false,
    [ROUTE_NAME]: 'ukkoturva_overview'
  }
}

/** @type {import('vue-router').RouteRecordRaw} */
export const UKKOTURVA_ROUTE_BENEFITS = {
  path: 'benefits-and-offers',
  name: 'ukkoturva_benefits_and_offers',
  component: () =>
    import('@/views/ukkoturva/UkkoAssuranceBenefitsAndOffers.vue'),
  meta: {
    scrollToTop: true,
    requiresAuth: true,
    showInMainNav: false,
    [ROUTE_NAME]: 'ukkoturva_benefits_and_offers',
    icon: '$star-outline'
  }
}

/** @type {import('vue-router').RouteRecordRaw} */
export const UKKOTURVA_ROUTE_COURSES_AND_GUIDES = {
  path: 'courses-and-guides',
  name: 'ukkoturva_courses_and_guides',
  component: () =>
    import('@/views/ukkoturva/UkkoAssuranceCoursesAndGuides.vue'),
  meta: {
    scrollToTop: true,
    requiresAuth: true,
    showInMainNav: false,
    [ROUTE_NAME]: 'ukkoturva_courses_and_guides',
    icon: '$monitor-account'
  }
}

/** @type {import('vue-router').RouteRecordRaw} */
export const UKKOTURVA_ROUTE_CONTRACT_LIBRARY = {
  path: 'contract-templates',
  name: 'ukkoturva_contract_templates',
  component: () =>
    import('@/views/ukkoturva/UkkoAssuranceContractTemplates.vue'),
  meta: {
    scrollToTop: true,
    requiresAuth: true,
    showInMainNav: false,
    [ROUTE_NAME]: 'ukkoturva_contract_templates',
    icon: '$clipboard-text-outline'
  }
}

export const UKKOTURVA_ROUTE_INSURANCES_NEED_FOR_MORE = {
  path: 'insurances-need-for-more',
  name: 'ukkoturva_insurances_need_for_more',
  component: () =>
    import('@/views/ukkoturva/UkkoAssuranceInsurancesNeedForMore.vue'),
  meta: {
    scrollToTop: true,
    requiresAuth: true,
    showInMainNav: false,
    [ROUTE_NAME]: 'ukkoturva_insurances_need_for_more'
  }
}

/** @type {import('vue-router').RouteRecordRaw} */
export const UKKOTURVA_ROUTE_INSURANCES_WHAT_TO_DO = {
  path: 'insurances-what-to-do',
  name: 'ukkoturva_insurances_what_to_do',
  component: () =>
    import('@/views/ukkoturva/UkkoAssuranceInsurancesWhatToDo.vue'),
  meta: {
    scrollToTop: true,
    requiresAuth: true,
    showInMainNav: false,
    [ROUTE_NAME]: 'ukkoturva_insurances_what_to_do'
  }
}

/** @type {import('vue-router').RouteRecordRaw} */
export const UKKOTURVA_ROUTE_INSURANCES_LIABILITY = {
  path: 'insurances-liability',
  name: 'ukkoturva_insurances_liability',
  component: () =>
    import('@/views/ukkoturva/UkkoAssuranceInsurancesLiability.vue'),
  meta: {
    scrollToTop: true,
    requiresAuth: true,
    showInMainNav: false,
    [ROUTE_NAME]: 'ukkoturva_insurances_liability'
  }
}

/** @type {import('vue-router').RouteRecordRaw} */
export const UKKOTURVA_ROUTE_INSURANCES_ACCIDENT = {
  path: 'insurances-accident',
  name: 'ukkoturva_insurances_accident',
  component: () =>
    import('@/views/ukkoturva/UkkoAssuranceInsurancesAccident.vue'),
  meta: {
    scrollToTop: true,
    requiresAuth: true,
    showInMainNav: false,
    [ROUTE_NAME]: 'ukkoturva_insurances_accident'
  }
}

/** @type {import('vue-router').RouteRecordRaw} */
export const UKKOTURVA_ROUTE_INSURANCES_LEGAL = {
  path: 'insurances-legal',
  name: 'ukkoturva_insurances_legal',
  component: () => import('@/views/ukkoturva/UkkoAssuranceInsurancesLegal.vue'),
  meta: {
    hide: process.env.VUE_APP_SERVICE === service.TLP,
    scrollToTop: true,
    requiresAuth: true,
    showInMainNav: false,
    [ROUTE_NAME]: 'ukkoturva_insurances_legal'
  }
}

/** @type {import('vue-router').RouteRecordRaw} */
export const UKKOTURVA_ROUTE_INSURANCES_CERTIFICATES = {
  path: 'insurance-certificates',
  name: 'ukkoturva_insurances_certificates',
  component: () =>
    import('@/views/ukkoturva/UkkoAssuranceInsuranceCertificates.vue'),
  meta: {
    scrollToTop: true,
    requiresAuth: true,
    showInMainNav: false,
    [ROUTE_NAME]: 'ukkoturva_insurances_certificates'
  }
}

const INSURANCES_CHILDREN_GENERAL = [
  UKKOTURVA_ROUTE_INSURANCES_ACCIDENT,
  UKKOTURVA_ROUTE_INSURANCES_LEGAL,
  UKKOTURVA_ROUTE_INSURANCES_LIABILITY,
  UKKOTURVA_ROUTE_INSURANCES_NEED_FOR_MORE,
  UKKOTURVA_ROUTE_INSURANCES_WHAT_TO_DO,
  UKKOTURVA_ROUTE_INSURANCES_CERTIFICATES
]

const INSURANCES_CHILDREN_TLP = [
  UKKOTURVA_ROUTE_INSURANCES_ACCIDENT,
  UKKOTURVA_ROUTE_INSURANCES_LIABILITY,
  UKKOTURVA_ROUTE_INSURANCES_NEED_FOR_MORE,
  UKKOTURVA_ROUTE_INSURANCES_WHAT_TO_DO,
  UKKOTURVA_ROUTE_INSURANCES_CERTIFICATES
]

/** @type {import('vue-router').RouteRecordRaw} */
export const UKKOTURVA_ROUTE_INSURANCES = {
  path: 'insurances',
  name: 'ukkoturva_insurances',
  component: () => import('@/views/ukkoturva/InsurancesIndex.vue'),
  meta: {
    scrollToTop: true,
    requiresAuth: true,
    showInMainNav: false,
    [ROUTE_NAME]: 'ukkoturva_insurances',
    icon: '$shield-plus-outline'
  },
  children:
    process.env.VUE_APP_SERVICE === service.TLP
      ? INSURANCES_CHILDREN_TLP
      : INSURANCES_CHILDREN_GENERAL
}

const getRoutes = () => [
  UKKOTURVA_ROUTE_OVERVIEW,
  UKKOTURVA_ROUTE_INSURANCES,
  UKKOTURVA_ROUTE_BENEFITS,
  UKKOTURVA_ROUTE_COURSES_AND_GUIDES,
  UKKOTURVA_ROUTE_CONTRACT_LIBRARY
]

const firstPath = getRoutes()[0]?.path

/** @type {import('vue-router').RouteRecordRaw} */
export const UKKOTURVA_ROUTE_ROOT = {
  path: '/ukkoturva',
  name: 'ukkoturva',
  redirect: `/ukkoturva/${firstPath}`,
  component: UkkoturvaIndex,
  meta: {
    [AUTHENTICATION_REQUIRED]: true,
    [IS_IN_MAIN_NAV]: true,
    icon: '$shield-outline',
    [ROUTE_NAME]: 'ukkoturva',
    [HIDE_TITLE_ON_MOBILE]: true
  },
  children: getRoutes()
}

export default [UKKOTURVA_ROUTE_ROOT]
